import { render, staticRenderFns } from "./TransportCertificate.vue?vue&type=template&id=588ee71b&"
import script from "./TransportCertificate.vue?vue&type=script&lang=js&"
export * from "./TransportCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports